var _path, _path2, _path3, _path4, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.66 146.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.27,45.63l-8.17,15.82s-1.39-3.23-5.75-5.02c-5.55-2.21-12.02,2.42-10.45,9.27,1.55,6.84,9.53,6.49,9.53,6.49l-8.59,16.63-17.78-9.18c-.23-.12-.47.06-.46.33,1.33,15.04-17.58,12.85-17.15,1.23.13-3.74,3.69-6.15,5.06-6.94.22-.13.21-.44-.02-.56l-17.83-9.21,7.83-15.15c.33-.64,1.22-.74,1.66-.15,1.02,1.34,2.72,2.46,4.19,3.22,3.82,1.98,8.52.48,10.49-3.34,3.53-6.83-3.6-12.93-10.02-11.52-.82.17-1.47-.65-1.13-1.4l7.9-15.85,18.37,9.07c.76.41,1.67-.15,1.61-.99-.1-1.81.04-4.56,1.31-7.01,5.14-9.96,25.25.69,10.78,12.88-.63.53-.52,1.52.21,1.89l18.39,9.5Z",
    fill: "#4caf50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2,128.8l-20.51-6.63c-.24-.08-.3-.4-.11-.56,1.25-.96,4.45-3.84,4.06-7.57-1.18-11.57-20.2-11.14-16.82,3.58.07.26-.16.49-.41.41l-19.16-5.74-.4-.47,6.45-17.52c.24-.69,1.12-.89,1.65-.38,1.19,1.19,3.03,2.07,4.58,2.63,4.07,1.42,8.5-.72,9.93-4.78,2.55-7.24-5.33-12.31-11.51-10.04-.76.29-1.54-.42-1.3-1.22l5.63-16.78,19.45,6.46c.81.31,1.62-.37,1.46-1.21-.35-1.79-.59-4.53.33-7.12,3.73-10.58,25.11-2.79,12.46,11.26-.54.62-.31,1.58.48,1.85l19.53,6.87-5.93,16.8s-1.82-3.01-6.38-4.18c-5.8-1.43-11.56,4.05-9.07,10.62,2.5,6.55,10.34,5.12,10.34,5.12l-4.76,18.59Z",
    fill: "#70bf73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.96,29.36l-18.37-9.07-7.9,15.85c-.34.75.31,1.57,1.13,1.4,6.42-1.42,13.54,4.68,10.02,11.51-1.98,3.82-6.67,5.32-10.49,3.34-1.48-.76-3.17-1.88-4.19-3.22-.45-.58-1.33-.49-1.67.15l-7.83,15.16,17.83,9.21c.23.12.24.43.02.56-1.38.79-4.93,3.2-5.06,6.94-.43,11.62,18.47,13.81,17.15-1.23-.01-.27.23-.45.46-.33l17.78,9.18,8.59-16.63s-7.97.35-9.53-6.49c-1.57-6.85,4.89-11.48,10.45-9.27,4.36,1.79,5.75,5.02,5.75,5.02l8.17-15.82-18.39-9.5c-.73-.38-.84-1.36-.21-1.89,14.46-12.19-5.64-22.84-10.79-12.88-1.26,2.45-1.41,5.2-1.31,7.01.05.84-.86,1.41-1.61.99Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2,128.8l-20.51-6.63c-.24-.08-.3-.4-.11-.56,1.25-.96,4.45-3.84,4.06-7.57-1.18-11.57-20.2-11.14-16.82,3.58.07.26-.16.49-.41.41l-19.16-5.74-.4-.47,6.45-17.52c.24-.69,1.12-.89,1.65-.38,1.19,1.19,3.03,2.07,4.58,2.63,4.07,1.42,8.5-.72,9.93-4.78,2.55-7.24-5.33-12.31-11.51-10.04-.76.29-1.54-.42-1.3-1.22l5.63-16.78,19.45,6.46c.81.31,1.62-.37,1.46-1.21-.35-1.79-.59-4.53.33-7.12,3.73-10.58,25.11-2.79,12.46,11.26-.54.62-.31,1.58.48,1.85l19.53,6.87-5.93,16.8s-1.82-3.01-6.38-4.18c-5.8-1.43-11.56,4.05-9.07,10.62,2.5,6.55,10.34,5.12,10.34,5.12l-4.76,18.59Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100.23,
    y1: 28.57,
    x2: 100.5,
    y2: 21.68,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 112.15,
    y1: 36.98,
    x2: 116.65,
    y2: 32.79,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 120.67,
    y1: 49.57,
    x2: 126.81,
    y2: 49.72,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.366da47b8022f74921962277bed4cb9a.svg";
export { ForwardRef as ReactComponent };